/**
 * This module exports the IRole interface for defining roles in Rocket.Chat Apps.
 * @module definition/roles
 */
export * from './IRole';
